"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("element-closest");
require("ie-array-find-polyfill");
var gdprLock_1 = require("../../tools/gdprLock");
if (!("__tfcapi" in window)) {
    window["__tfcapi"] = function () { };
}
var vendorListMemo;
var fdmgPurposes = [
    {
        id: null,
        vendorName: "youtube",
        purposes: [],
    },
    {
        id: null,
        vendorName: "twitter",
        purposes: [],
    },
    {
        id: null,
        vendorName: "instagram",
        purposes: [],
    },
    {
        id: null,
        vendorName: "soundcloud",
        purposes: [],
    },
    {
        id: null,
        vendorName: "vimeo",
        purposes: [],
    },
    {
        id: null,
        vendorName: "inline-html",
        purposes: [],
    },
];
function consentVendor(vendorName) {
    if (vendorName === void 0) { vendorName = ""; }
    if ((vendorName && vendorName !== "inline-html") || !window.__tcfapi) {
        (0, gdprLock_1.activateVendor)(vendorName);
    }
    else {
        window.__tcfapi("accept", 2, function (result) {
            window.location.reload();
        });
    }
}
if (window.__tcfapi) {
    window.__tcfapi("addEventListener", 2, function (result) {
        window.location.reload();
    }, "consentManagerClosed");
    window.__tcfapi("addEventListener", 2, function (result) {
        window.location.reload();
    }, "consentNoticeClosed");
    window.__tcfapi("addEventListener", 2, function (result) {
        window.location.reload();
    }, "saveAndExitButtonClicked");
    window.__tcfapi("addEventListener", 2, function (result) {
        window.location.reload();
    }, "denyAllButtonClicked");
    window.__tcfapi("addEventListener", 2, function (result) {
        window.location.reload();
    }, "acceptAllButtonClicked");
    window.__tcfapi("addEventListener", 2, function (e) {
        (0, gdprLock_1.activateVendor)("inline-html");
        window.__tcfapi("getVendorList", 2, function (vendorList) {
            vendorListMemo = Object.values(vendorList.vendors);
            vendorListMemo.forEach(function (vendor) {
                fdmgPurposes.forEach(function (fdmgPurpose) {
                    if (fdmgPurpose.vendorName.toLowerCase() ===
                        vendor.name.toLowerCase()) {
                        fdmgPurpose.id = vendor.id;
                        fdmgPurpose.purposes = vendor.purposes;
                        window.__tcfapi("checkConsent", 2, function (data, success) {
                            if (data) {
                                (0, gdprLock_1.activateVendor)(fdmgPurpose.vendorName);
                            }
                            else {
                                (0, gdprLock_1.showLock)(fdmgPurpose.vendorName);
                            }
                        }, {
                            data: [
                                {
                                    vendorId: vendor.id,
                                    purposeIds: vendor.purposes,
                                },
                            ],
                        });
                    }
                });
            });
        });
    }, "cmpReady");
    var footerLink = document.querySelector('.menu-link[href="/cookiesettings"]');
    if (footerLink) {
        footerLink.addEventListener("click", function (e) {
            e.preventDefault();
            window.__tcfapi("showConsentManager", 2);
        });
    }
}
var consentButtons = document.querySelectorAll(".blocked-content-container");
if (consentButtons.length) {
    [].slice.call(consentButtons).forEach(function (button) {
        button.addEventListener("click", function () {
            var vendorName = button.getAttribute("data-vendor-name") || "";
            var foundVendor = vendorListMemo
                ? vendorListMemo.find(function (vendor) { return vendor.name.toLowerCase() === vendorName; })
                : true;
            if (!foundVendor) {
                consentVendor("");
            }
            else {
                var template = document.querySelector("textarea[data-vendor-name=\"" + vendorName + "\"],template[data-vendor-name=\"" + vendorName + "\"],script[data-vendor-name=\"" + vendorName + "\"]");
                if (template) {
                    window.__tcfapi("accept", 2, console.log, {
                        vendorIds: [foundVendor.id],
                        purposeIds: foundVendor.purposes,
                    });
                    consentVendor(vendorName);
                }
                else {
                    consentVendor(vendorName);
                }
            }
        });
    });
}
